module.exports = __webpack_public_path__ + "static/media/bs.1c87d3a7.jpeg";